const HOSTNAME_TO_CREATOR_SLUG: Record<string, string> = {
  "browze.in": "eleganceny",
  "shop-with-caroline.com": "shop.with.caroline",
  "www.shop-with-caroline.com": "shop.with.caroline",
  "coachsimran.com": "drsimran.malhotra",
  "www.coachsimran.com": "drsimran.malhotra",
};

/**
 * Creator username/slug implied by the current (or given) hostname: Browsable subdomains,
 * dev `{slug}.localhost`, and hard-mapped custom domains. Used by routing and SPA paths.
 */
export function getCreatorSlugFromHost(hostname?: string): string | undefined {
  const hn = String(hostname ?? (typeof window !== "undefined" ? window.location.hostname : "")).trim();
  if (!hn) return undefined;
  const h = hn.toLowerCase();

  const browsableSuffixes = [".browsable.ai", ".browsable.bio"] as const;
  for (const suffix of browsableSuffixes) {
    if (h.endsWith(suffix)) {
      const sub = h.slice(0, -suffix.length);
      if (sub && sub !== "www") return sub;
    }
  }

  const localhostSuffix = ".localhost";
  if (h.endsWith(localhostSuffix) && h !== "localhost") {
    const sub = h.slice(0, -localhostSuffix.length);
    if (sub && sub !== "www") return sub;
  }

  return HOSTNAME_TO_CREATOR_SLUG[h];
}

/** `{slug}.browsable.ai` / `.bio` / `.localhost` — hostname IS the username. */
export function isNativeCreatorSubdomainHost(hostname?: string): boolean {
  const h = String(
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""),
  )
    .trim()
    .toLowerCase();
  if (!h) return false;
  for (const suffix of [".browsable.ai", ".browsable.bio"] as const) {
    if (h.endsWith(suffix)) {
      const sub = h.slice(0, -suffix.length);
      return Boolean(sub && sub !== "www");
    }
  }
  if (h.endsWith(".localhost") && h !== "localhost") {
    const sub = h.slice(0, -".localhost".length);
    return Boolean(sub && sub !== "www");
  }
  return false;
}
